module.exports = __webpack_public_path__ + "img/93.ba07edcd.webp";